import { DropzoneFile } from 'components/Dropzone/utils';
import { ObjectValues } from 'types';

export const SPONSORED_ADVERT_STATUS = {
  PAUSED: 'Paused',
  DRAFTED: 'Drafted',
  PUBLISHED: 'Published',
} as const;

export type SponsoredAdvertStatus = ObjectValues<
  typeof SPONSORED_ADVERT_STATUS
>;

export const SPONSORED_ADVERT_CARD_TYPE = {
  STRIP_AD: 'Strip ad',
  MED_REC: 'Med Rec',
  BOTH: 'Both',
} as const;

export type CardType = ObjectValues<typeof SPONSORED_ADVERT_CARD_TYPE>;

export type SponsoredAdvert = {
  _id: string;
  title: string;
  description: string;
  link: string;
  coverPhoto: DropzoneFile;
  status: SponsoredAdvertStatus;
  logoImage: DropzoneFile;
  ctaText: string;
  cardType: CardType;
};
